function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PublishSettingsTemplate = require('./publish-settings.template');
var PublishSettingsOverlay = /*#__PURE__*/function () {
  function PublishSettingsOverlay(app, mod) {
    _classCallCheck(this, PublishSettingsOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.createNftOverlay = null;
    this.postState = {
      published: false,
      accessLevel: 'public',
      // 'public', 'private', 'subscription'
      accessMode: 'transferable',
      // kept for publish intent; not shown in UI
      description: '',
      image: null,
      imageUrl: null,
      customCSS: ''
    };
    // Wizard navigation + distribution options (survive access switches via preserveStep)
    this.wizardState = {
      step: 1,
      hasSaito: null,
      hasAccessKey: null,
      isListedInStore: null,
      createNftStatus: null,
      pendingNftId: null,
      pendingNftSignature: null,
      // Same-session mint tx — wallet NFT records keep slips/tx_sig only.
      pendingNftTx: null,
      // Distribution options (default checked).
      linkToProfile: true,
      tweetOnPublish: true
    };
    this._isSliding = false;
    // Stack post signatures already cross-posted to RedSquare this session.
    this._redSquareCrossPostedSigs = new Set();
  }

  /**
   * Read persisted distribution choices from the editor session (if any).
   */
  return _createClass(PublishSettingsOverlay, [{
    key: "readPersistedDistribution",
    value: function readPersistedDistribution() {
      var _this$mod$create_post;
      var saved = (_this$mod$create_post = this.mod.create_post_ui) === null || _this$mod$create_post === void 0 ? void 0 : _this$mod$create_post.publishDistribution;
      if (!saved || _typeof(saved) !== 'object') {
        return {
          linkToProfile: true,
          tweetOnPublish: true
        };
      }
      return {
        linkToProfile: saved.linkToProfile !== false,
        tweetOnPublish: saved.tweetOnPublish !== false
      };
    }

    /**
     * Persist distribution choices on the editor so overlay re-opens keep them.
     */
  }, {
    key: "persistDistribution",
    value: function persistDistribution() {
      if (!this.mod.create_post_ui) {
        return;
      }
      this.mod.create_post_ui.publishDistribution = {
        linkToProfile: this.wizardState.linkToProfile !== false,
        tweetOnPublish: this.wizardState.tweetOnPublish !== false
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var postData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$preserveStep = options.preserveStep,
        preserveStep = _options$preserveStep === void 0 ? false : _options$preserveStep;
      this.postState = _objectSpread(_objectSpread({}, this.postState), postData);
      if (!preserveStep) {
        var distribution = this.readPersistedDistribution();
        this.wizardState = {
          step: 1,
          hasSaito: null,
          hasAccessKey: null,
          isListedInStore: null,
          createNftStatus: null,
          pendingNftId: null,
          pendingNftSignature: null,
          pendingNftTx: null,
          linkToProfile: distribution.linkToProfile,
          tweetOnPublish: distribution.tweetOnPublish
        };
        this.persistDistribution();
      }
      if (this.postState.accessLevel === 'private' || this.postState.accessLevel === 'subscription') {
        if (!this.postState.accessMode) {
          this.postState.accessMode = 'transferable';
        }
      } else if (this.postState.accessLevel === 'public') {
        this.postState.accessMode = null;
      }
      if (this.mod.create_post_ui && this.mod.create_post_ui.featuredImage) {
        this.postState.image = this.mod.create_post_ui.featuredImage;
      }
      var html = PublishSettingsTemplate(this.app, this.mod, this.postState, this.wizardState);
      this.overlay.show(html);
      setTimeout(function () {
        _this.attachEvents();
      }, 25);
    }

    /**
     * Re-render only the step panel + action buttons without remounting the overlay.
     * Used for wizard Next/Back with horizontal slide animation.
     */
  }, {
    key: "renderStep",
    value: function () {
      var _renderStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var direction,
          panel,
          actionBar,
          exitClass,
          enterClass,
          html,
          temp,
          newPanel,
          newActionBar,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              direction = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'forward';
              if (!this._isSliding) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this._isSliding = true;
              panel = document.querySelector('#stack-publish-step-panel');
              actionBar = document.querySelector('.publish .actions');
              if (panel) {
                _context.n = 2;
                break;
              }
              this._isSliding = false;
              this.render(this.postState, {
                preserveStep: true
              });
              return _context.a(2);
            case 2:
              exitClass = direction === 'forward' ? 'slide-exit-left' : 'slide-exit-right';
              enterClass = direction === 'forward' ? 'slide-enter-right' : 'slide-enter-left';
              panel.classList.add(exitClass);
              _context.n = 3;
              return this._wait(180);
            case 3:
              html = PublishSettingsTemplate(this.app, this.mod, this.postState, this.wizardState);
              temp = document.createElement('div');
              temp.innerHTML = html.trim();
              newPanel = temp.querySelector('#stack-publish-step-panel');
              newActionBar = temp.querySelector('.publish .actions');
              if (!newPanel) {
                _context.n = 4;
                break;
              }
              newPanel.classList.add(enterClass);
              panel.replaceWith(newPanel);
              // Double rAF so the enter transform is painted before we ease to rest
              _context.n = 4;
              return new Promise(function (resolve) {
                requestAnimationFrame(function () {
                  requestAnimationFrame(function () {
                    newPanel.classList.remove(enterClass);
                    resolve();
                  });
                });
              });
            case 4:
              if (actionBar && newActionBar) {
                actionBar.replaceWith(newActionBar);
              }
              this.attachEvents();
              _context.n = 5;
              return this._wait(220);
            case 5:
              this._isSliding = false;
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function renderStep() {
        return _renderStep.apply(this, arguments);
      }
      return renderStep;
    }()
  }, {
    key: "_wait",
    value: function _wait(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var overlayCloseBtn = document.querySelector('.saito-overlay-close');
      if (overlayCloseBtn) {
        overlayCloseBtn.onclick = function () {
          _this2.overlay.hide();
        };
      }
      var accessCards = document.querySelectorAll('.publish .access-card');
      var accessCheckboxes = document.querySelectorAll('.publish .access-checkbox');
      accessCards.forEach(function (card) {
        card.onclick = function (e) {
          if (e.target.type === 'checkbox') {
            return;
          }
          var checkbox = card.querySelector('.access-checkbox');
          var accessValue = card.getAttribute('data-access');
          accessCheckboxes.forEach(function (cb) {
            if (cb !== checkbox) {
              var _cb$closest;
              cb.checked = false;
              (_cb$closest = cb.closest('.access-card')) === null || _cb$closest === void 0 || _cb$closest.classList.remove('active');
            }
          });
          checkbox.checked = true;
          card.classList.add('active');
          _this2.setAccessLevel(accessValue);
        };
      });
      accessCheckboxes.forEach(function (checkbox) {
        checkbox.onchange = function () {
          var card = checkbox.closest('.access-card');
          var accessValue = card === null || card === void 0 ? void 0 : card.getAttribute('data-access');
          if (checkbox.checked) {
            accessCheckboxes.forEach(function (cb) {
              if (cb !== checkbox) {
                var _cb$closest2;
                cb.checked = false;
                (_cb$closest2 = cb.closest('.access-card')) === null || _cb$closest2 === void 0 || _cb$closest2.classList.remove('active');
              }
            });
            card === null || card === void 0 || card.classList.add('active');
            _this2.setAccessLevel(accessValue);
          } else {
            checkbox.checked = true;
          }
        };
      });
      var profileToggle = document.querySelector('.publish [data-action="toggle-profile-link"]');
      if (profileToggle) {
        profileToggle.onchange = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var _this2$mod$updateProf, _this2$mod, _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                _this2.wizardState.linkToProfile = profileToggle.checked;
                _this2.persistDistribution();
                // Uncheck removes the Profile stack link immediately.
                // Check only records intent — Profile is updated on Publish.
                if (profileToggle.checked) {
                  _context2.n = 4;
                  break;
                }
                _context2.p = 1;
                _context2.n = 2;
                return (_this2$mod$updateProf = (_this2$mod = _this2.mod).updateProfile) === null || _this2$mod$updateProf === void 0 ? void 0 : _this2$mod$updateProf.call(_this2$mod, '');
              case 2:
                _context2.n = 4;
                break;
              case 3:
                _context2.p = 3;
                _t = _context2.v;
                console.warn('Stack: profile link clear failed', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
                profileToggle.checked = true;
                _this2.wizardState.linkToProfile = true;
                _this2.persistDistribution();
              case 4:
                return _context2.a(2);
            }
          }, _callee2, null, [[1, 3]]);
        }));
      }
      var tweetToggle = document.querySelector('.publish [data-action="toggle-tweet-on-publish"]');
      if (tweetToggle) {
        tweetToggle.onchange = function () {
          _this2.wizardState.tweetOnPublish = tweetToggle.checked;
          _this2.persistDistribution();
        };
      }
      var deleteDraftBtn = document.querySelector('#stack-publish-delete-draft-btn');
      if (deleteDraftBtn) {
        deleteDraftBtn.onclick = function (e) {
          e.preventDefault();
          _this2.handleDeleteDraft();
        };
      }
      var backBtn = document.querySelector('#stack-publish-back-btn');
      if (backBtn) {
        backBtn.onclick = function (e) {
          e.preventDefault();
          _this2.handleBack();
        };
      }
      var publishImmediately = document.querySelector('#stack-publish-immediately');
      if (publishImmediately) {
        var publishNow = function publishNow(e) {
          e.preventDefault();
          _this2.handlePublish();
        };
        publishImmediately.onclick = publishNow;
        publishImmediately.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            publishNow(e);
          }
        };
      }

      // Panel 2 — open Create NFT with Stack Access type pre-selected
      var createKeysLink = document.querySelector('#stack-create-access-key-link');
      if (createKeysLink) {
        createKeysLink.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this2.openCreateNft();
        };
      }
      var listKeysLink = document.querySelector('#stack-list-access-key-link');
      if (listKeysLink) {
        listKeysLink.onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var _access_key_nft$getTo;
            var seller, nftList, rec, _iterator, _step, _r$slip, _r$slip2, r, nftType, creator, SaitoNFT, access_key_nft, total, _t2;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.p = _context3.n) {
                case 0:
                  e.preventDefault();
                  e.stopPropagation();
                  seller = _this2.app.modules.returnFirstRespondTo('saito-sell-nft');
                  if (seller) {
                    _context3.n = 1;
                    break;
                  }
                  return _context3.a(2);
                case 1:
                  nftList = _this2.app.options.wallet.nfts || [];
                  rec = null;
                  _iterator = _createForOfIteratorHelper(nftList);
                  _context3.p = 2;
                  _iterator.s();
                case 3:
                  if ((_step = _iterator.n()).done) {
                    _context3.n = 8;
                    break;
                  }
                  r = _step.value;
                  nftType = _this2.app.wallet.extractNFTType(((_r$slip = r.slip3) === null || _r$slip === void 0 ? void 0 : _r$slip.utxo_key) || '');
                  if (!(nftType !== 'stack')) {
                    _context3.n = 4;
                    break;
                  }
                  return _context3.a(3, 7);
                case 4:
                  if (!(_this2.wizardState.pendingNftSignature && r.tx_sig === _this2.wizardState.pendingNftSignature)) {
                    _context3.n = 5;
                    break;
                  }
                  rec = r;
                  return _context3.a(3, 8);
                case 5:
                  if (!(_this2.wizardState.pendingNftId && r.id === _this2.wizardState.pendingNftId)) {
                    _context3.n = 6;
                    break;
                  }
                  rec = r;
                  return _context3.a(3, 8);
                case 6:
                  creator = ((_r$slip2 = r.slip1) === null || _r$slip2 === void 0 ? void 0 : _r$slip2.public_key) || '';
                  if (!(creator === _this2.mod.publicKey)) {
                    _context3.n = 7;
                    break;
                  }
                  rec = r;
                  return _context3.a(3, 8);
                case 7:
                  _context3.n = 3;
                  break;
                case 8:
                  _context3.n = 10;
                  break;
                case 9:
                  _context3.p = 9;
                  _t2 = _context3.v;
                  _iterator.e(_t2);
                case 10:
                  _context3.p = 10;
                  _iterator.f();
                  return _context3.f(10);
                case 11:
                  if (rec) {
                    _context3.n = 12;
                    break;
                  }
                  return _context3.a(2);
                case 12:
                  SaitoNFT = require('../../../../../lib/saito/ui/saito-nft/saito-nft'); // Prefer the mint tx retained from create (wallet records do not store full txs).
                  access_key_nft = new SaitoNFT(_this2.app, _this2.mod, _this2.wizardState.pendingNftTx || null, rec);
                  if (!(!access_key_nft.tx && typeof access_key_nft.fetchTransaction === 'function')) {
                    _context3.n = 13;
                    break;
                  }
                  _context3.n = 13;
                  return new Promise(function (resolve) {
                    var settled = false;
                    var finish = function finish() {
                      if (!settled) {
                        settled = true;
                        resolve();
                      }
                    };
                    access_key_nft.fetchTransaction(finish);
                    setTimeout(finish, 8000);
                  });
                case 13:
                  if (access_key_nft.tx) {
                    _context3.n = 14;
                    break;
                  }
                  siteMessage('Could not load the Access Key transaction yet. Wait a moment and try again.', 4000);
                  return _context3.a(2);
                case 14:
                  total = Number(((_access_key_nft$getTo = access_key_nft.getTotalAmount) === null || _access_key_nft$getTo === void 0 ? void 0 : _access_key_nft$getTo.call(access_key_nft)) || access_key_nft.amount || rec.amount || 1) || 1;
                  seller.render({
                    nft: access_key_nft,
                    quantity: Math.max(1, total - 1),
                    callback: function callback(result) {
                      if ((result === null || result === void 0 ? void 0 : result.status) === 'listed') {
                        _this2.wizardState.isListedInStore = true;
                        _this2.render(_this2.postState, {
                          preserveStep: true
                        });
                      }
                    }
                  });
                case 15:
                  return _context3.a(2);
              }
            }, _callee3, null, [[2, 9, 10, 11]]);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
      var tokensLink = document.querySelector('#stack-publish-tokens-link');
      if (tokensLink) {
        tokensLink.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
        };
      }
      var primaryBtn = document.querySelector('#stack-publish-primary-btn');
      if (primaryBtn) {
        primaryBtn.onclick = function (e) {
          e.preventDefault();
          var action = primaryBtn.getAttribute('data-action') || 'publish';
          if (action === 'next') {
            _this2.handleNext();
          } else {
            _this2.handlePublish();
          }
        };
      }
    }

    /**
     * Open the shared Create NFT dialog with Stack Access type pre-selected.
     * Prefers the header-owned instance so we do not register a second event listener.
     */
  }, {
    key: "openCreateNft",
    value: function () {
      var _openCreateNft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this3 = this;
        var createNft, CreateNFT, username, wallet_balance, quantity, image, imgPath, response, blob, defaults, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              createNft = this.mod.header && this.mod.header.select_nft_overlay && this.mod.header.select_nft_overlay.create_nft_overlay;
              if (!createNft) {
                if (!this.createNftOverlay) {
                  CreateNFT = require('../../../../../lib/saito/ui/saito-nft/overlays/create-overlay');
                  this.createNftOverlay = new CreateNFT(this.app, this.mod);
                }
                createNft = this.createNftOverlay;
              }
              username = this.app.keychain.returnUsername(this.mod.publicKey) || 'this author';
              _context4.n = 1;
              return this.app.wallet.getBalance('SAITO');
            case 1:
              wallet_balance = _context4.v;
              quantity = 1;
              if (Number(wallet_balance) > 100) {
                quantity = 100;
              } else if (Number(wallet_balance) > 10) {
                quantity = 10;
              }
              this.wizardState.createQuantity = quantity;
              _context4.p = 2;
              imgPath = this.postState.accessLevel === 'subscription' ? '/stack/img/saito-stack-subscription.png' : '/stack/img/saito-stack-access-key.png';
              _context4.n = 3;
              return fetch(imgPath);
            case 3:
              response = _context4.v;
              if (!response.ok) {
                _context4.n = 6;
                break;
              }
              _context4.n = 4;
              return response.blob();
            case 4:
              blob = _context4.v;
              _context4.n = 5;
              return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function () {
                  return resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              });
            case 5:
              image = _context4.v;
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t3 = _context4.v;
            case 8:
              defaults = {
                type: 'stack',
                title: 'Stack Access Key',
                description: "This NFT provides read-access to ".concat(username, "'s posts on Saito Stack."),
                quantity: quantity,
                deposit: quantity,
                locked: ['type'],
                callback: function callback(obj) {
                  if ((obj === null || obj === void 0 ? void 0 : obj.status) === 'created') {
                    _this3.wizardState.createNftStatus = 'waiting';
                    _this3.wizardState.pendingNftId = obj.nft_id || null;
                    _this3.wizardState.pendingNftSignature = obj.signature || null;
                    _this3.wizardState.pendingNftTx = obj.tx || null;
                    var keyLabel = _this3.postState.accessLevel === 'subscription' ? 'Subscription Key' : 'Access Key';
                    _this3.overlay.hide();
                    _this3.watchTransaction(obj.tx, {
                      title: "Creating ".concat(keyLabel),
                      lead: "Your ".concat(keyLabel, " is being broadcast..."),
                      successTitle: "".concat(keyLabel, " Confirmed"),
                      successLead: "Your ".concat(keyLabel, " has been confirmed and is available in your wallet."),
                      onConfirmed: function onConfirmed() {
                        _this3.wizardState.createNftStatus = 'confirmed';
                        _this3.wizardState.hasAccessKey = true;
                        _this3.render(_this3.postState, {
                          preserveStep: true
                        });
                      },
                      onCancelled: function onCancelled() {
                        _this3.wizardState.createNftStatus = 'cancelled';
                        _this3.render(_this3.postState, {
                          preserveStep: true
                        });
                      }
                    });
                    return;
                  }
                  if ((obj === null || obj === void 0 ? void 0 : obj.status) === 'cancelled') {
                    _this3.wizardState.createNftStatus = 'cancelled';
                    _this3.render(_this3.postState, {
                      preserveStep: true
                    });
                  }
                }
              };
              if (image) {
                defaults.image = image;
              }
              createNft.render(defaults);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 7]]);
      }));
      function openCreateNft() {
        return _openCreateNft.apply(this, arguments);
      }
      return openCreateNft;
    }()
  }, {
    key: "handleDeleteDraft",
    value: function handleDeleteDraft() {
      var _this4 = this;
      if (confirm('Are you sure you want to delete this draft? This action cannot be undone.')) {
        if (this.mod.create_post_ui && this.mod.create_post_ui.draftTransaction) {
          this.app.storage.deleteTransaction(this.mod.create_post_ui.draftTransaction, null, 'localhost').then(function () {
            _this4.mod.create_post_ui.draftTransaction = null;
            var editor = document.querySelector('#stack-post-body-editor');
            if (editor && _this4.mod.create_post_ui) {
              var _require = require('../../post-document'),
                parseMarkdownToDocument = _require.parseMarkdownToDocument,
                renderDocument = _require.renderDocument;
              var emptyDocument = parseMarkdownToDocument('');
              renderDocument(emptyDocument, editor, {
                contentEditable: true
              });
              _this4.mod.create_post_ui.updatePlaceholderVisibility();
              _this4.mod.create_post_ui.updatePublishTriggerVisibility();
            }
            var titleInput = document.querySelector('#stack-post-title-input');
            if (titleInput) {
              titleInput.value = '';
            }
            _this4.overlay.hide();
            if (_this4.mod.main) {
              setTimeout(function () {
                _this4.mod.main.render();
              }, 100);
            }
            siteMessage('Draft deleted', 1500);
          })["catch"](function (error) {
            console.error('Error deleting draft transaction:', error);
            siteMessage('Failed to delete draft. Please try again.');
          });
        } else {
          var editor = document.querySelector('#stack-post-body-editor');
          if (editor && this.mod.create_post_ui) {
            var _require2 = require('../../post-document'),
              parseMarkdownToDocument = _require2.parseMarkdownToDocument,
              renderDocument = _require2.renderDocument;
            var emptyDocument = parseMarkdownToDocument('');
            renderDocument(emptyDocument, editor, {
              contentEditable: true
            });
            this.mod.create_post_ui.updatePlaceholderVisibility();
            this.mod.create_post_ui.updatePublishTriggerVisibility();
          }
          var titleInput = document.querySelector('#stack-post-title-input');
          if (titleInput) {
            titleInput.value = '';
          }
          this.overlay.hide();
          if (this.mod.main) {
            setTimeout(function () {
              _this4.mod.main.render();
            }, 100);
          }
          siteMessage('Draft deleted', 1500);
        }
      }
    }
  }, {
    key: "setAccessLevel",
    value: function setAccessLevel(level) {
      // Only reset when the access type actually changes
      if (this.postState.accessLevel === level) {
        return;
      }
      this.postState.accessLevel = level;
      if (level === 'public') {
        this.postState.accessMode = null;
      } else if ((level === 'private' || level === 'subscription') && !this.postState.accessMode) {
        this.postState.accessMode = 'transferable';
      }

      // Changing access type always returns to step 1
      this.wizardState.step = 1;
      this.wizardState.hasAccessKey = null;
      this.wizardState.isListedInStore = null;
      this.wizardState.hasSaito = null;
      this.wizardState.createNftStatus = null;
      this.wizardState.pendingNftId = null;
      this.wizardState.pendingNftSignature = null;
      this.wizardState.pendingNftTx = null;
      this.wizardState.createQuantity = null;
      this.render(this.postState, {
        preserveStep: true
      });
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      if (this.wizardState.step <= 1) {
        this.overlay.hide();
        return;
      }
      this.wizardState.step -= 1;
      this.renderStep('back');
    }
  }, {
    key: "handleNext",
    value: function () {
      var _handleNext = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var level, nextStep, keyState, wallet_balance, quantity;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              level = this.postState.accessLevel;
              if (!(level !== 'private' && level !== 'subscription')) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              nextStep = this.wizardState.step + 1; // Resolve checks when entering panel 2
              if (!(nextStep === 2)) {
                _context5.n = 4;
                break;
              }
              _context5.n = 2;
              return this.resolveAccessKeyState();
            case 2:
              keyState = _context5.v;
              this.wizardState.hasSaito = keyState.hasSaito;
              this.wizardState.hasAccessKey = keyState.hasAccessKey;
              this.wizardState.createNftStatus = null;
              _context5.n = 3;
              return this.app.wallet.getBalance('SAITO');
            case 3:
              wallet_balance = _context5.v;
              quantity = 1;
              if (Number(wallet_balance) > 100) {
                quantity = 100;
              } else if (Number(wallet_balance) > 10) {
                quantity = 10;
              }
              this.wizardState.createQuantity = quantity;
            case 4:
              this.wizardState.step = Math.min(nextStep, 2);
              _context5.n = 5;
              return this.renderStep('forward');
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleNext() {
        return _handleNext.apply(this, arguments);
      }
      return handleNext;
    }()
    /**
     * Future: check wallet SAITO balance and whether an appropriate Access Key NFT exists.
     * Until wired, returns unresolved stubs so the UI shows the create path.
     *
     * @returns {Promise<{ hasSaito: boolean|null, hasAccessKey: boolean|null }>}
     */
  }, {
    key: "resolveAccessKeyState",
    value: function () {
      var _resolveAccessKeyState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var nftList, _iterator2, _step2, _rec$slip, _rec$slip2, rec, nftType, creator, _t4, _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.app.wallet.updateNFTList();
            case 1:
              nftList = this.app.options.wallet.nfts || [];
              _iterator2 = _createForOfIteratorHelper(nftList);
              _context6.p = 2;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context6.n = 6;
                break;
              }
              rec = _step2.value;
              nftType = this.app.wallet.extractNFTType(((_rec$slip = rec.slip3) === null || _rec$slip === void 0 ? void 0 : _rec$slip.utxo_key) || '');
              if (!(nftType !== 'stack')) {
                _context6.n = 4;
                break;
              }
              return _context6.a(3, 5);
            case 4:
              creator = ((_rec$slip2 = rec.slip1) === null || _rec$slip2 === void 0 ? void 0 : _rec$slip2.public_key) || '';
              if (!(creator === this.mod.publicKey)) {
                _context6.n = 5;
                break;
              }
              return _context6.a(2, {
                hasSaito: null,
                hasAccessKey: true
              });
            case 5:
              _context6.n = 3;
              break;
            case 6:
              _context6.n = 8;
              break;
            case 7:
              _context6.p = 7;
              _t4 = _context6.v;
              _iterator2.e(_t4);
            case 8:
              _context6.p = 8;
              _iterator2.f();
              return _context6.f(8);
            case 9:
              _context6.n = 11;
              break;
            case 10:
              _context6.p = 10;
              _t5 = _context6.v;
              console.warn('Stack publish: resolveAccessKeyState', _t5);
            case 11:
              return _context6.a(2, {
                hasSaito: null,
                hasAccessKey: false
              });
          }
        }, _callee6, this, [[2, 7, 8, 9], [0, 10]]);
      }));
      function resolveAccessKeyState() {
        return _resolveAccessKeyState.apply(this, arguments);
      }
      return resolveAccessKeyState;
    }()
    /**
     * Future: check whether the Access Key NFT is already listed in the Saito Store.
     * Until wired, returns unresolved stub so the UI offers listing.
     *
     * @returns {Promise<{ isListedInStore: boolean|null }>}
     */
  }, {
    key: "resolveStoreListingState",
    value: function () {
      var _resolveStoreListingState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              return _context7.a(2, {
                isListedInStore: null
              });
          }
        }, _callee7);
      }));
      function resolveStoreListingState() {
        return _resolveStoreListingState.apply(this, arguments);
      }
      return resolveStoreListingState;
    }()
  }, {
    key: "watchTransaction",
    value: function watchTransaction(tx) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$title = _ref3.title,
        title = _ref3$title === void 0 ? 'Waiting for Confirmation' : _ref3$title,
        _ref3$lead = _ref3.lead,
        lead = _ref3$lead === void 0 ? '' : _ref3$lead,
        _ref3$subtitle = _ref3.subtitle,
        subtitle = _ref3$subtitle === void 0 ? '' : _ref3$subtitle,
        _ref3$successTitle = _ref3.successTitle,
        successTitle = _ref3$successTitle === void 0 ? 'Confirmed' : _ref3$successTitle,
        _ref3$successLead = _ref3.successLead,
        successLead = _ref3$successLead === void 0 ? '' : _ref3$successLead,
        _ref3$onConfirmed = _ref3.onConfirmed,
        onConfirmed = _ref3$onConfirmed === void 0 ? null : _ref3$onConfirmed,
        _ref3$onCancelled = _ref3.onCancelled,
        onCancelled = _ref3$onCancelled === void 0 ? null : _ref3$onCancelled;
      if (!this.mod.transaction_monitor) {
        console.error('Stack: transaction_monitor is not initialized');
        if (typeof onCancelled === 'function') {
          onCancelled();
        }
        return;
      }
      this.mod.transaction_monitor.render({
        tx: tx,
        title: title,
        lead: lead,
        subtitle: subtitle,
        successTitle: successTitle,
        successLead: successLead,
        successActionLabel: 'Continue',
        callback: function callback(result) {
          if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
            if (typeof onConfirmed === 'function') {
              onConfirmed(result);
            }
            return;
          }
          if ((result === null || result === void 0 ? void 0 : result.status) === 'cancelled') {
            if (typeof onCancelled === 'function') {
              onCancelled(result);
            }
          }
        }
      });
    }
  }, {
    key: "handlePublish",
    value: function () {
      var _handlePublish = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this5 = this;
        var wallet_balance, title, content, titleEmpty, contentEmpty, _this$mod$create_post2, parent_id, draftIdToDelete, draftTxToDelete, featuredImage, visibility, publishIntent, accessMode, _accessMode, publishedTx, txmsg, from, incomingLogicalPostId, postParentId, authorPosts, filteredAuthorPosts, post, existingIndex, _authorPosts, _existingIndex, deleted, _this$mod$returnStack, _this$mod, _this$mod$returnProfi, _this$mod2, url, _this$mod$updateProfi, _this$mod3, isUpdate, _parent_id, _t6, _t7, _t8;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.n = 1;
              return this.app.wallet.getBalance('SAITO');
            case 1:
              wallet_balance = _context8.v;
              if (!(Number(wallet_balance) == 0)) {
                _context8.n = 2;
                break;
              }
              siteMessage('A Saito balance is needed to Publish Posts...', 3000);
              this.app.connection.emit('saito-purchase-launch');
              return _context8.a(2);
            case 2:
              title = this.mod.create_post_ui && typeof this.mod.create_post_ui.getDocumentTitle === 'function' ? this.mod.create_post_ui.getDocumentTitle() : document.querySelector('#stack-post-title-input') ? document.querySelector('#stack-post-title-input').value || '' : '';
              content = '';
              if (this.mod.create_post_ui) {
                // ------------------------------------------------------------
                // CRITICAL: Build imageIdMap BEFORE serialization (publish mode)
                // ------------------------------------------------------------
                if (typeof this.mod.create_post_ui.buildImageIdMap === 'function') {
                  this.mod.create_post_ui.buildImageIdMap();
                }
                content = this.mod.create_post_ui.serializeDOMToMarkdown(this.mod.create_post_ui.imageIdMap || null);
              }

              // ========================================================================
              // VALIDATION GUARD: Prevent publishing empty posts (no title AND no content)
              // ========================================================================
              titleEmpty = !title.trim();
              contentEmpty = !content.trim();
              if (!(titleEmpty && contentEmpty)) {
                _context8.n = 3;
                break;
              }
              siteMessage('Please add a title or some content before publishing.');
              return _context8.a(2);
            case 3:
              _context8.p = 3;
              parent_id = this.mod.create_post_ui && this.mod.create_post_ui.parent_id ? this.mod.create_post_ui.parent_id : null;
              if (parent_id) {
                siteMessage('Updating post...', 1500);
              } else {
                siteMessage('Publishing post...', 1500);
              }
              draftIdToDelete = this.mod.create_post_ui ? this.mod.create_post_ui.activeDraftId : null;
              draftTxToDelete = this.mod.create_post_ui ? this.mod.create_post_ui.draftTransaction : null;
              featuredImage = this.mod.create_post_ui && this.mod.create_post_ui.featuredImage ? this.mod.create_post_ui.featuredImage : this.postState.image || ''; // ========================================================================
              // PUBLISH INTENT: Generate normalized intent object from UI selection
              // ========================================================================
              visibility = this.postState.accessLevel || 'public';
              if (visibility === 'public') {
                publishIntent = {
                  visibility: 'public',
                  access_mode: null,
                  time_limit: null,
                  author: this.mod.publicKey
                };
              } else if (visibility === 'private') {
                accessMode = this.postState.accessMode || 'transferable';
                publishIntent = {
                  visibility: 'private',
                  access_mode: accessMode,
                  time_limit: null,
                  author: this.mod.publicKey
                };
              } else if (visibility === 'subscription') {
                _accessMode = this.postState.accessMode || 'transferable';
                publishIntent = {
                  visibility: 'subscription',
                  access_mode: _accessMode,
                  time_limit: null,
                  author: this.mod.publicKey
                };
              } else {
                publishIntent = {
                  visibility: 'public',
                  access_mode: null,
                  time_limit: null,
                  author: this.mod.publicKey
                };
              }
              _context8.n = 4;
              return this.mod.createStackPostTransaction({
                title: title,
                content: content,
                image: featuredImage,
                images: Array.isArray((_this$mod$create_post2 = this.mod.create_post_ui) === null || _this$mod$create_post2 === void 0 ? void 0 : _this$mod$create_post2.images) ? this.mod.create_post_ui.images : [],
                imageUrl: this.postState.imageUrl,
                tags: [],
                timestamp: Date.now(),
                subscriptionTier: this.postState.accessLevel === 'public' ? 'free' : 'paid',
                excerpt: this.postState.description || content.substring(0, 200).replace(/\n/g, ' ').trim(),
                publishIntent: publishIntent,
                accessLevel: this.postState.accessLevel,
                parent_id: parent_id
              }, function () {
                _this5.postState.published = true;
              });
            case 4:
              publishedTx = _context8.v;
              if (parent_id && this.mod.applyOptimisticPostUpdate) {
                this.mod.applyOptimisticPostUpdate(publishedTx);
              }
              if (publishedTx && publishedTx.signature) {
                txmsg = publishedTx.returnMessage();
                from = publishedTx.from && publishedTx.from.length > 0 ? publishedTx.from[0].publicKey : this.mod.publicKey;
                if (txmsg && txmsg.data && from) {
                  incomingLogicalPostId = this.mod.getLogicalPostId(publishedTx);
                  postParentId = txmsg.data.parent_id || null;
                  if (this.mod.postsCache) {
                    if (this.mod.postsCache.allPosts) {
                      try {
                        this.mod.postsCache.allPosts = this.mod.postsCache.allPosts.filter(function (p) {
                          if (!p) return false;
                          try {
                            return _this5.mod.getLogicalPostIdFromPost(p) !== incomingLogicalPostId;
                          } catch (err) {
                            console.warn('Stack: Error filtering post from allPosts cache:', err);
                            return true;
                          }
                        });
                      } catch (err) {
                        console.error('Stack: Error filtering allPosts cache:', err);
                      }
                    }
                    if (this.mod.postsCache.byAuthor && this.mod.postsCache.byAuthor.has(from)) {
                      try {
                        authorPosts = this.mod.postsCache.byAuthor.get(from);
                        filteredAuthorPosts = authorPosts.filter(function (p) {
                          if (!p) return false;
                          try {
                            return _this5.mod.getLogicalPostIdFromPost(p) !== incomingLogicalPostId;
                          } catch (err) {
                            console.warn('Stack: Error filtering post from byAuthor cache:', err);
                            return true;
                          }
                        });
                        this.mod.postsCache.byAuthor.set(from, filteredAuthorPosts);
                      } catch (err) {
                        console.error('Stack: Error filtering byAuthor cache:', err);
                      }
                    }
                  }
                  post = _objectSpread(_objectSpread({}, txmsg.data), {}, {
                    sig: publishedTx.signature,
                    publicKey: from,
                    timestamp: txmsg.data.timestamp || publishedTx.timestamp,
                    lastEdited: txmsg.data.timestamp || publishedTx.timestamp,
                    parent_id: postParentId
                  });
                  this.mod.transactionCache[publishedTx.signature] = publishedTx;
                  if (this.mod.postsCache && this.mod.postsCache.allPosts) {
                    existingIndex = this.mod.postsCache.allPosts.findIndex(function (p) {
                      return p.sig === publishedTx.signature;
                    });
                    if (existingIndex < 0) {
                      this.mod.postsCache.allPosts.push(post);
                    } else {
                      this.mod.postsCache.allPosts[existingIndex] = post;
                    }
                  }
                  if (this.mod.postsCache && this.mod.postsCache.byAuthor) {
                    if (!this.mod.postsCache.byAuthor.has(from)) {
                      this.mod.postsCache.byAuthor.set(from, []);
                    }
                    _authorPosts = this.mod.postsCache.byAuthor.get(from);
                    _existingIndex = _authorPosts.findIndex(function (p) {
                      return p.sig === publishedTx.signature;
                    });
                    if (_existingIndex < 0) {
                      _authorPosts.push(post);
                    } else {
                      _authorPosts[_existingIndex] = post;
                    }
                  }
                }
              }
              console.log('[DRAFT-CHECK] Publishing post - deleting draft:', draftIdToDelete || 'N/A');
              if (!(draftIdToDelete && this.mod.deleteDraft)) {
                _context8.n = 6;
                break;
              }
              _context8.n = 5;
              return this.mod.deleteDraft(draftIdToDelete);
            case 5:
              deleted = _context8.v;
              console.log('[DRAFT-CHECK] Draft deleted from archive and memory:', deleted);
              _context8.n = 11;
              break;
            case 6:
              if (!draftTxToDelete) {
                _context8.n = 11;
                break;
              }
              _context8.p = 7;
              _context8.n = 8;
              return this.app.storage.deleteTransaction(draftTxToDelete, null, 'localhost');
            case 8:
              if (!this.mod.refreshDrafts) {
                _context8.n = 9;
                break;
              }
              _context8.n = 9;
              return this.mod.refreshDrafts();
            case 9:
              console.log('[DRAFT-CHECK] Draft transaction deleted via fallback');
              _context8.n = 11;
              break;
            case 10:
              _context8.p = 10;
              _t6 = _context8.v;
              console.warn('Stack: Error deleting draft transaction:', _t6);
            case 11:
              if (this.mod.create_post_ui) {
                this.mod.create_post_ui.activeDraftId = null;
                this.mod.create_post_ui.draftTransaction = null;
                this.mod.create_post_ui.sessionIntent = null;
                this.mod.create_post_ui.isPublished = true;
              }

              // Checked: ensure Profile has the Stack URL (no-op if already set).
              // Same distribution option for every access level.
              if (!(this.wizardState.linkToProfile !== false)) {
                _context8.n = 15;
                break;
              }
              _context8.p = 12;
              url = ((_this$mod$returnStack = (_this$mod = this.mod).returnStackUrl) === null || _this$mod$returnStack === void 0 ? void 0 : _this$mod$returnStack.call(_this$mod, this.mod.publicKey)) || '';
              if (!(url && ((_this$mod$returnProfi = (_this$mod2 = this.mod).returnProfileStackUrl) === null || _this$mod$returnProfi === void 0 ? void 0 : _this$mod$returnProfi.call(_this$mod2)) !== url)) {
                _context8.n = 13;
                break;
              }
              _context8.n = 13;
              return (_this$mod$updateProfi = (_this$mod3 = this.mod).updateProfile) === null || _this$mod$updateProfi === void 0 ? void 0 : _this$mod$updateProfi.call(_this$mod3, url);
            case 13:
              _context8.n = 15;
              break;
            case 14:
              _context8.p = 14;
              _t7 = _context8.v;
              console.warn('Stack: profile stack link publish skipped', (_t7 === null || _t7 === void 0 ? void 0 : _t7.message) || _t7);
            case 15:
              if (!(this.wizardState.tweetOnPublish !== false)) {
                _context8.n = 16;
                break;
              }
              _context8.n = 16;
              return this.crossPostToRedSquare(publishedTx, title);
            case 16:
              this.overlay.hide();
              if (this.mod.create_post_ui && typeof this.mod.create_post_ui.onEditorUnmount === 'function') {
                this.mod.create_post_ui.onEditorUnmount();
              }
              isUpdate = !!parent_id;
              this.watchTransaction(publishedTx, {
                title: isUpdate ? 'Updating Post' : 'Publishing Post',
                lead: 'Your post is being broadcast...',
                successTitle: isUpdate ? 'Post Updated' : 'Post Published',
                successLead: isUpdate ? 'Your update has been confirmed and is now available on the network.' : 'Your post has been confirmed and is now available on the network.',
                onConfirmed: function onConfirmed() {
                  _this5.openPublishedPost(publishedTx);
                },
                onCancelled: function onCancelled() {
                  // Transaction was already broadcast — still open the post view.
                  _this5.openPublishedPost(publishedTx);
                }
              });
              _context8.n = 18;
              break;
            case 17:
              _context8.p = 17;
              _t8 = _context8.v;
              console.error('Error publishing post:', _t8);
              _parent_id = this.mod.create_post_ui && this.mod.create_post_ui.parent_id ? this.mod.create_post_ui.parent_id : null;
              if (_parent_id) {
                siteMessage('Unable to update post', 3000);
              } else {
                siteMessage('Unable to publish post', 3000);
              }
              siteMessage('Failed to publish post. Please try again.');
            case 18:
              return _context8.a(2);
          }
        }, _callee8, this, [[12, 14], [7, 10], [3, 17]]);
      }));
      function handlePublish() {
        return _handlePublish.apply(this, arguments);
      }
      return handlePublish;
    }()
    /**
     * Create a normal RedSquare post linking to the published Stack article.
     * Idempotent per Stack post signature for this overlay session.
     * Only runs after Stack publish returned a signed transaction.
     */
  }, {
    key: "crossPostToRedSquare",
    value: function () {
      var _crossPostToRedSquare = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(publishedTx) {
        var _publishedTx$returnMe, _this$app$modules$ret, _this$app$modules, _this$app$modules$ret2, _this$app$modules2, _window$location;
        var title,
          stackSig,
          parentId,
          redsquare,
          authorPublicKey,
          path,
          absoluteUrl,
          articleTitle,
          data,
          tweetTx,
          _redsquare$manager,
          _redsquare$manager$on,
          tweet,
          _args9 = arguments,
          _t9,
          _t0;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              title = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : '';
              if (!(!publishedTx || !publishedTx.signature)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              stackSig = String(publishedTx.signature);
              if (!this._redSquareCrossPostedSigs.has(stackSig)) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              // Updates to an existing article should not spawn another tweet.
              parentId = ((_publishedTx$returnMe = publishedTx.returnMessage) === null || _publishedTx$returnMe === void 0 || (_publishedTx$returnMe = _publishedTx$returnMe.call(publishedTx)) === null || _publishedTx$returnMe === void 0 || (_publishedTx$returnMe = _publishedTx$returnMe.data) === null || _publishedTx$returnMe === void 0 ? void 0 : _publishedTx$returnMe.parent_id) || null;
              if (!parentId) {
                _context9.n = 3;
                break;
              }
              return _context9.a(2);
            case 3:
              redsquare = ((_this$app$modules$ret = (_this$app$modules = this.app.modules).returnModule) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'RedSquare')) || ((_this$app$modules$ret2 = (_this$app$modules2 = this.app.modules).returnModuleByName) === null || _this$app$modules$ret2 === void 0 ? void 0 : _this$app$modules$ret2.call(_this$app$modules2, 'RedSquare'));
              if (!(!redsquare || typeof redsquare.createTweetTransaction !== 'function')) {
                _context9.n = 4;
                break;
              }
              return _context9.a(2);
            case 4:
              authorPublicKey = this.mod.publicKey;
              if (authorPublicKey) {
                _context9.n = 5;
                break;
              }
              return _context9.a(2);
            case 5:
              path = "/".concat(this.mod.slug, "/").concat(authorPublicKey, "/").concat(stackSig);
              absoluteUrl = typeof window !== 'undefined' && (_window$location = window.location) !== null && _window$location !== void 0 && _window$location.origin ? "".concat(window.location.origin).concat(path) : path;
              articleTitle = String(title || '').trim() || 'Untitled';
              data = {
                text: "".concat(articleTitle, "\n").concat(absoluteUrl)
              }; // Mark before await so retries / double-confirm cannot duplicate.
              this._redSquareCrossPostedSigs.add(stackSig);
              _context9.p = 6;
              _context9.n = 7;
              return redsquare.createTweetTransaction(data, []);
            case 7:
              tweetTx = _context9.v;
              _context9.n = 8;
              return tweetTx.sign();
            case 8:
              _context9.n = 9;
              return this.app.network.propagateTransaction(tweetTx);
            case 9:
              if (!(redsquare.browser_active && typeof redsquare.receiveTweetTransaction === 'function')) {
                _context9.n = 13;
                break;
              }
              _context9.p = 10;
              _context9.n = 11;
              return redsquare.receiveTweetTransaction(tweetTx);
            case 11:
              tweet = _context9.v;
              (_redsquare$manager = redsquare.manager) === null || _redsquare$manager === void 0 || (_redsquare$manager$on = _redsquare$manager.onTweetPosted) === null || _redsquare$manager$on === void 0 || _redsquare$manager$on.call(_redsquare$manager, tweet);
              _context9.n = 13;
              break;
            case 12:
              _context9.p = 12;
              _t9 = _context9.v;
              console.warn('Stack: RedSquare local receive skipped', (_t9 === null || _t9 === void 0 ? void 0 : _t9.message) || _t9);
            case 13:
              _context9.n = 15;
              break;
            case 14:
              _context9.p = 14;
              _t0 = _context9.v;
              // Allow a later retry if propagation failed.
              this._redSquareCrossPostedSigs["delete"](stackSig);
              console.warn('Stack: RedSquare cross-post failed', (_t0 === null || _t0 === void 0 ? void 0 : _t0.message) || _t0);
            case 15:
              return _context9.a(2);
          }
        }, _callee9, this, [[10, 12], [6, 14]]);
      }));
      function crossPostToRedSquare(_x2) {
        return _crossPostToRedSquare.apply(this, arguments);
      }
      return crossPostToRedSquare;
    }()
  }, {
    key: "openPublishedPost",
    value: function openPublishedPost(publishedTx) {
      var _publishedTx$returnMe2;
      if (!this.mod.viewPostComponent) {
        var ViewPost = require('../view-post');
        this.mod.viewPostComponent = new ViewPost(this.app, this.mod, '.saito-container');
      }
      this.mod.viewPostComponent.render(publishedTx);
      if (publishedTx && publishedTx.signature) {
        var authorPublicKey = this.mod.publicKey;
        if (authorPublicKey) {
          var canonicalUrl = "/".concat(this.mod.slug, "/").concat(authorPublicKey, "/").concat(publishedTx.signature);
          window.history.pushState({
            view: 'stack_post',
            publicKey: authorPublicKey,
            signature: publishedTx.signature
          }, null, canonicalUrl);
        }
      }
      var finalParentId = publishedTx ? ((_publishedTx$returnMe2 = publishedTx.returnMessage()) === null || _publishedTx$returnMe2 === void 0 || (_publishedTx$returnMe2 = _publishedTx$returnMe2.data) === null || _publishedTx$returnMe2 === void 0 ? void 0 : _publishedTx$returnMe2.parent_id) || null : null;
      if (finalParentId) {
        siteMessage('Post updated', 1500);
      } else {
        siteMessage('Stack post published', 1500);
      }
    }
  }, {
    key: "handleViewPreview",
    value: function handleViewPreview() {
      this.overlay.hide();
      if (this.mod.previewOverlay) {
        this.mod.previewOverlay.render();
      }
    }
  }]);
}();
module.exports = PublishSettingsOverlay;